import { QuestionChangesAffectingResponsesArray, QuestionDangerousChangeType, QuestionLevelDangerousChange } from "../types/syncCheckResult";

export const willChangeAffectResponses = (questionLevelDangerousChanges: QuestionLevelDangerousChange[]) => questionLevelDangerousChanges?.some((change) =>
  (
    QuestionChangesAffectingResponsesArray as readonly QuestionDangerousChangeType[]
  ).includes(change.type)
);
